'use client';

import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { XIcon } from '@phosphor-icons/react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { Avatar, AvatarFallback } from './avatar';
import { IconButton } from './icon-button';
import { cn } from './lib/cn';
function Drawer(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DrawerPrimitive.Root data-slot="drawer" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DrawerTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DrawerPrimitive.Trigger data-slot="drawer-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DrawerPortal(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DrawerPrimitive.Portal data-slot="drawer-portal" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DrawerClose(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DrawerPrimitive.Close data-slot="drawer-close" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DrawerOverlay(t0) {
  const $ = _c(10);
  let className;
  let overlayClassname;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      overlayClassname,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = overlayClassname;
    $[3] = props;
  } else {
    className = $[1];
    overlayClassname = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== overlayClassname) {
    t1 = cn("data-closed:fade-out-0 data-open:fade-in-0 fixed inset-0 z-999 bg-black/10 data-closed:animate-out data-open:animate-in supports-backdrop-filter:backdrop-blur-xs", className, overlayClassname);
    $[4] = className;
    $[5] = overlayClassname;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <DrawerPrimitive.Overlay className={t1} data-slot="drawer-overlay" {...props} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
const PORTALED_OVERLAY_CONTENT_SELECTOR = ['[data-slot="popover-content"]', '[data-slot="dropdown-menu-content"]', '[data-slot="select-content"]'].join(', ');
function isPortaledOverlayTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(PORTALED_OVERLAY_CONTENT_SELECTOR) !== null;
}
function DrawerContent(t0) {
  const $ = _c(24);
  let children;
  let className;
  let onPointerDownOutside;
  let overlayClassname;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      children,
      overlayClassname,
      hideDrag: t1,
      onPointerDownOutside,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = onPointerDownOutside;
    $[4] = overlayClassname;
    $[5] = props;
    $[6] = t1;
  } else {
    children = $[1];
    className = $[2];
    onPointerDownOutside = $[3];
    overlayClassname = $[4];
    props = $[5];
    t1 = $[6];
  }
  const hideDrag = t1 === undefined ? false : t1;
  let t2;
  if ($[7] !== overlayClassname) {
    t2 = <DrawerOverlay overlayClassname={overlayClassname} />;
    $[7] = overlayClassname;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== className) {
    t3 = cn("group/drawer-content fixed z-999 flex h-fit flex-col gap-4 bg-background p-4 pt-2 text-sm outline-none data-[vaul-drawer-direction=bottom]:inset-x-0 data-[vaul-drawer-direction=top]:inset-x-0 data-[vaul-drawer-direction=left]:inset-y-0 data-[vaul-drawer-direction=right]:inset-y-0 data-[vaul-drawer-direction=top]:top-0 data-[vaul-drawer-direction=right]:right-0 data-[vaul-drawer-direction=bottom]:bottom-0 data-[vaul-drawer-direction=left]:left-0 data-[vaul-drawer-direction=bottom]:mt-24 data-[vaul-drawer-direction=top]:mb-24 data-[vaul-drawer-direction=bottom]:max-h-[98vh] data-[vaul-drawer-direction=top]:max-h-[98vh] data-[vaul-drawer-direction=left]:w-3/4 data-[vaul-drawer-direction=right]:w-3/4 data-[vaul-drawer-direction=bottom]:rounded-t-4xl data-[vaul-drawer-direction=left]:rounded-r-4xl data-[vaul-drawer-direction=top]:rounded-b-4xl data-[vaul-drawer-direction=right]:rounded-l-4xl data-[vaul-drawer-direction=bottom]:border-t data-[vaul-drawer-direction=left]:border-r data-[vaul-drawer-direction=top]:border-b data-[vaul-drawer-direction=right]:border-l data-[vaul-drawer-direction=left]:sm:max-w-sm data-[vaul-drawer-direction=right]:sm:max-w-sm", className);
    $[9] = className;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== onPointerDownOutside) {
    t4 = event => {
      if (isPortaledOverlayTarget(event.target)) {
        event.preventDefault();
      }
      onPointerDownOutside?.(event);
    };
    $[11] = onPointerDownOutside;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== hideDrag) {
    t5 = hideDrag ? null : <div className="mx-auto hidden h-1 w-[100px] shrink-0 rounded-full bg-role-surface-container group-data-[vaul-drawer-direction=bottom]/drawer-content:block" />;
    $[13] = hideDrag;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== children || $[16] !== props || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <DrawerPrimitive.Content className={t3} data-slot="drawer-content" onPointerDownOutside={t4} {...props}>{t5}{children}</DrawerPrimitive.Content>;
    $[15] = children;
    $[16] = props;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t2 || $[22] !== t6) {
    t7 = <DrawerPortal data-slot="drawer-portal">{t2}{t6}</DrawerPortal>;
    $[21] = t2;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}
function DrawerHeader(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className,
      hideClose: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const hideClose = t1 === undefined ? false : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("flex items-center justify-start gap-4 text-left data-[vaul-drawer-direction=bottom]/drawer-content:text-left group-data-[vaul-drawer-direction=top]/drawer-content:text-left", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== hideClose) {
    t3 = hideClose ? null : <DrawerHeaderClose />;
    $[7] = hideClose;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== props || $[11] !== t2 || $[12] !== t3) {
    t4 = <div className={t2} data-slot="drawer-header" {...props}>{children}{t3}</div>;
    $[9] = children;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function DrawerHeaderClose(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("ml-auto shrink-0", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <XIcon weight="bold" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <DrawerClose asChild={true}><IconButton appearance="outlined" className={t1} {...props}>{t2}</IconButton></DrawerClose>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function DrawerHeaderIcon(t0) {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <Avatar size="48"><AvatarFallback size="48" variant="icon" {...props}>{children}</AvatarFallback></Avatar>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function DrawerHeaderVStack(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("flex flex-col gap-2", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function DrawerBody(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("flex min-h-0 flex-col overflow-y-auto", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} data-slot="drawer-body" {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function DrawerFooter(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex flex-col-reverse gap-4", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} data-slot="drawer-footer" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DrawerTitle(t0) {
  const $ = _c(6);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className || $[4] !== props) {
    t1 = <DrawerPrimitive.Title className={className} data-slot="drawer-title" {...props} />;
    $[3] = className;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function DrawerDescription(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("font-inter text-[16px] text-role-on-background leading-[24px]", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <DrawerPrimitive.Description className={t1} data-slot="drawer-description" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { Drawer, DrawerBody, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerHeaderClose, DrawerHeaderIcon, DrawerHeaderVStack, DrawerOverlay, DrawerPortal, DrawerTitle, DrawerTrigger };